import styled from 'styled-components';

export const StyledAnchor = styled.a`
	color: ${({ theme }) => theme.colors.primary.main};
	text-decoration: none;

	&:hover,
	&:focus {
		filter: brightness(1.1);
	}
`;
